<template>
	<div>
		<v-card>

			<v-tabs
				v-model="sección"
				background-color="primary"
				dark
			>
				<v-tab>Principal</v-tab>
				<v-tab v-if="datos_.identificador">Movimiento de inventario</v-tab>
			</v-tabs>

			<v-tabs-items v-model="sección">
				<v-tab-item>
					<v-card flat>

						<v-card-title class="headline">Producto</v-card-title>

						<v-card-text>
							<v-text-field
								v-model="datos_.código"
								maxlength="20"
								label="Código"
								required
							></v-text-field>

							<v-text-field
								v-model="datos_.descripción"
								maxlength="50"
								label="Descripción del producto"
								required
							></v-text-field>

							<v-text-field
								v-model="datos_.precioDeCoste.monto"
								type="number"
								min="0"
								label="Precio de coste (opcional)"
								hint="No use separadores de miles."
							></v-text-field>

							<v-text-field
								v-model="datos_._precio"
								type="number"
								min="0"
								label="Precio de venta unitario, antes de impuestos"
								hint="No use separadores de miles."
								required
							></v-text-field>

							<v-text-field
								v-model="datos_.enInventario"
								type="number"
								min="0"
								label="Cantidad en inventario"
								:readonly="!!datos_.identificador"
							></v-text-field>

							<v-select
								v-model="datos_.definiciónDeImpuestos"
								:items="definicionesDeImpuestos.listado"
								item-text="descripción"
								item-value="identificador"
								label="Definición de impuestos"
							></v-select>

							<div class="d-flex" style="align-items: center">
								<img :src="datos_._imagenPrincipalSRC" width="100" height="100" style="object-fit: contain; border: 1px solid silver" alt="Sin imagen">
								<div style="flex-grow: 1; margin-left: 10px;">
									<v-file-input
										v-model="datos_._imagenPrincipal"
										prepend-icon="mdi-camera"
										label="Seleccionar imagen de muestra (opcional)"
										accept="image/*"
										class="pt-0"
										hide-details
									></v-file-input>
									<v-checkbox
										v-if="datos_.identificador && datos_._imagenPrincipalSRC"
										v-model="datos_._eliminarImagenPrincipal"
										:label="datos_._eliminarImagenPrincipal ? 'Se eliminará la imagen al guardar' : 'Eliminar imagen'"
										color="red"
										hide-details
									></v-checkbox>
								</div>
							</div>

							<v-switch
								v-model="datos_.habilitado"
								:label="datos_.habilitado ? 'Habilitado' : 'Deshabilitado'"
								class="my-6"
								color="success"
							></v-switch>

						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>

							<v-btn
								color="grey darken-1"
								text
								:disabled="fuente.guardando"
								@click="cancelar"
							>
								Cancelar
							</v-btn>

							<v-btn
								color="green darken-1"
								text
								:loading="fuente.guardando"
								@click="guardar"
							>
								Guardar
							</v-btn>
						</v-card-actions>

					</v-card>
				</v-tab-item>

				<v-tab-item v-if="datos_.identificador">
					<v-card flat>

						<v-card-title cclass="headline">{{ datos_.descripción }}</v-card-title>

						<v-card-text>

							<div style="max-height: 500px; overflow: auto" class="mb-12">
								<h4>Movimiento de inventario de este producto:</h4>
								<movimiento-de-inventario-de-producto :identificador="datos_.identificador"></movimiento-de-inventario-de-producto>
							</div>

						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color="grey darken-1"
								text
								:disabled="fuente.guardando"
								@click="cancelar"
							>
								Cerrar
							</v-btn>
						</v-card-actions>

					</v-card>
				</v-tab-item>

			</v-tabs-items>

		</v-card>
	</div>
</template>

<script>
import { productos, definicionesDeImpuestos } from '@/../../cliente_comun/fuentes'
import { imagen, notificación } from '@/../../cliente_comun/utilidades'
import movimientoDeInventarioDeProducto from '@/components/movimientoDeInventarioDeProducto.vue'

export default {
	name: 'producto',
	data: () => ({
		fuente: productos,
		definicionesDeImpuestos: definicionesDeImpuestos,
		sección: 'principal',
		datos_: {
			identificador: '',
			habilitado: true,
			código: '',
			descripción: '',
			enInventario: 1,
			definiciónDeImpuestos: '',
			precioDeCoste: {
				monto: '',
				moneda: 'COP'
			},
			_precio: '',
			_imagenPrincipal: null,
			_imagenPrincipalSRC: '',
			_eliminarImagenPrincipal: false,
		},
	}),
	props: ['datos'],
	components: {
		movimientoDeInventarioDeProducto
	},
	watch: {
		datos: {
			handler: function(d) {
				if (!d) {
					this.limpiar()
					return
				}

				this.datos_.identificador = d.identificador
				this.datos_.habilitado = !!d.habilitado
				this.datos_.código = d.código
				this.datos_.descripción = d.descripción
				this.datos_.enInventario = d.enInventario
				this.datos_.definiciónDeImpuestos = d.definiciónDeImpuestos
				this.datos_.precioDeCoste.monto = d.precioDeCoste && d.precioDeCoste.monto ? d.precioDeCoste.monto : ''
				this.datos_._precio = d.precios[0].monto
				this.datos_._imagenPrincipalSRC = d.imágenes && d.imágenes.principal ? d.imágenes.principal.pequeña : ''
				this.datos_._imagenPrincipal = null
				this.datos_._eliminarImagenPrincipal = false
				this.datos_.imágenes = d.imágenes
			},
			deep: true
		},
		'datos_._imagenPrincipal': {
			handler: function() {
				if (this.datos_._imagenPrincipal) {
					let aceptable = this.datos_._imagenPrincipal.type !== 'image/vnd.adobe.photoshop' && this.datos_._imagenPrincipal.type !== 'image/tiff'
					if (imagen.tipo(this.datos_._imagenPrincipal) === 'imagen' && aceptable) {
						this.datos_._imagenPrincipalSRC = window.URL.createObjectURL(this.datos_._imagenPrincipal)
					} else {
						notificación.error('Seleccione una imagen válida.')
						this.datos_._imagenPrincipal = null
						this.datos_._imagenPrincipalSRC = ''
					}
				} else {
					this.datos_._imagenPrincipalSRC = ''
				}
			},
			deep: true
		}
	},
	mounted: function() {
		this.definicionesDeImpuestos.inicializar()
	},
	methods: {
		guardar: function() {
			this.fuente.guardar(this.datos_, this.datos_.identificador).then( () => {
				this.limpiar()
				this.$emit('guardar', true)
			})
		},
		cancelar: function() {
			this.limpiar()
			this.$emit('cancelar', true)
		},
		limpiar: function() {
			this.datos_.identificador = ''
			this.datos_.habilitado = true
			this.datos_.código = ''
			this.datos_.descripción = ''
			this.datos_.enInventario = ''
			this.datos_.definiciónDeImpuestos = ''
			this.datos_.precioDeCoste.monto = ''
			this.datos_._precio = ''
			this.datos_._imagenPrincipal = null
			this.datos_._imagenPrincipalSRC = ''
			this.datos_._eliminarImagenPrincipal = false
			if (this.datos_.imágenes && this.datos_.imágenes.principal) {
				this.datos_.imágenes.principal.pequeña = ''
				this.datos_.imágenes.principal.grande = ''
			}
		},
	}
}
</script>